const aa = (parent,addHeight) => {
    if (parent) {
        parent.classList.add("sub-menu--visible");
        parent.style.maxHeight = parent.dataset.originalMaxHeight || '';
        let newHeight = parseInt(parent.style.maxHeight, 10) || 0;
        if(addHeight) {
            
            newHeight += parent.scrollHeight+addHeight;

        }
        else {
            newHeight += parent.scrollHeight;

        }
        parent.style.maxHeight = newHeight + "px";
      }
}

const ab = (parent) => {
    if (parent) {
          parent.classList.remove("sub-menu--visible");
          parent.style.maxHeight = parent.dataset.originalMaxHeight || '';

      }
}
let mobileReveal = async () =>{
  await new Promise(r => setTimeout(r, 1));
    document.querySelectorAll('.menu-item-has-children').forEach(parent => {
      const child = parent.querySelector('.sub-menu');
      if (child) {
        child.dataset.originalMaxHeight = child.style.maxHeight || '';
        parent.querySelector("a").addEventListener('click', (e) => {
        
        if (child.classList.contains("sub-menu--clicked")) {
          e.preventDefault();
          child.classList.remove("sub-menu--visible");
          child.classList.remove("sub-menu--clicked");
          child.style.maxHeight = child.dataset.originalMaxHeight;
          parent.classList.remove("parent--active");
        } else {
          e.preventDefault();
          child.classList.add("sub-menu--visible");
          child.classList.add("sub-menu--clicked");
          child.style.maxHeight = child.dataset.originalMaxHeight;
          let newHeight = parseInt(child.style.maxHeight, 10) || 0;
          newHeight += child.scrollHeight;
          child.style.maxHeight = newHeight + "px";
          parent.classList.add("parent--active");

          aa(child.parentNode.parentNode,newHeight);
        }
      });
    }
  });
}
export const animateSubMenuReveal = () => {
    const navbarItems = document.querySelectorAll('.navbar__items');

    if (!navbarItems) return;
    navbarItems.forEach(navbarItem=>{
      navbarItem.querySelectorAll("& > .menu-item-has-children").forEach(item=>{
        item.addEventListener('mouseenter', (event) => {
            const parent = event.target.querySelector('.sub-menu');
            aa(parent);
          });

          item.addEventListener('mouseleave', (event) => {
            const parent = event.target.querySelector('.sub-menu');
            document.querySelectorAll('.sub-menu .menu-item-has-children').forEach(parent => {
                parent.classList.remove("parent--active");
                const child = parent.querySelector('.sub-menu');
                if (child) {
                    child.classList.remove("sub-menu--visible");
                    child.classList.remove("sub-menu--clicked");
                    child.style.maxHeight = '';
                }
            });
            ab(parent);
          });
    })
    })
   
   
  
  
    // If clicked sub sub menu
    document.querySelectorAll('.sub-menu .menu-item-has-children').forEach(parent => {
        const child = parent.querySelector('.sub-menu');
        if (child) {
          child.dataset.originalMaxHeight = child.style.maxHeight || '';
          parent.querySelector("a").addEventListener('click', (e) => {
           
          if (child.classList.contains("sub-menu--clicked")) {
            e.preventDefault();
            child.classList.remove("sub-menu--visible");
            child.classList.remove("sub-menu--clicked");
            child.style.maxHeight = child.dataset.originalMaxHeight;
            parent.classList.remove("parent--active");
            // ab(child.parentNode.parentNode);
          } else {
            e.preventDefault();
            child.classList.add("sub-menu--visible");
            child.classList.add("sub-menu--clicked");
            child.style.maxHeight = child.dataset.originalMaxHeight;
            let newHeight = parseInt(child.style.maxHeight, 10) || 0;
            newHeight += child.scrollHeight;
            child.style.maxHeight = newHeight + "px";
            parent.classList.add("parent--active");

            aa(child.parentNode.parentNode,newHeight);
          }
        });
      }
    });



    if(window.innerWidth<1140){
    mobileReveal();

    }






  };

  
  